"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOverdue = exports.getDueDateGroupByKey = void 0;
const texts_1 = require("../texts");
const intl_1 = require("../locale/intl");
const date_1 = require("./date");
const isAfter_1 = __importDefault(require("date-fns/isAfter"));
const endOfDay_1 = __importDefault(require("date-fns/endOfDay"));
function getDueDateGroupByKey(value, userPreferences) {
    var _a;
    const timezone = (_a = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.timezone.value) !== null && _a !== void 0 ? _a : "UTC";
    const dueDate = (0, date_1.dateValueToDate)(value === null || value === void 0 ? void 0 : value.to_date, timezone);
    if (!dueDate) {
        return "";
    }
    if (value.status_is_completed) {
        return (0, intl_1.$t)(texts_1.dueDateFieldText.complete);
    }
    const now = (0, date_1.getNow)(timezone);
    if (isOverdue(dueDate, now, value.to_date.include_time)) {
        return (0, intl_1.$t)(texts_1.dueDateFieldText.overdue);
    }
    return (0, intl_1.$t)(texts_1.dueDateFieldText.in_progress);
}
exports.getDueDateGroupByKey = getDueDateGroupByKey;
function isOverdue(dueDate, now, includeTime) {
    if (includeTime) {
        return (0, isAfter_1.default)(now, dueDate);
    }
    return (0, isAfter_1.default)(now, (0, endOfDay_1.default)(dueDate));
}
exports.isOverdue = isOverdue;
